import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';

let setAutoComplete = false;
//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: ['au']
      }
    };

    var input = document.getElementById('JobContactSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        for (var i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] == "street_number") {
            formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "route") {
            formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "locality") {
            formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
          }
          if (place.address_components[i].types[0] == "postal_code") {
            formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "country") {
            formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
          }
        }
        formComponent.formRef.current?.setFieldValue('JobContactSearchAddress', place.formatted_address);
      }
    })
  }
}

export function addClientJobTemplateContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

export function editClientJobTemplateContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

//选Same As Contact Address时给Postal Address赋值
export function setSameAsContactAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
    formComponent.formRef.current?.setFieldValue('PostalCountry', formComponent.formRef.current?.getFieldValue('Country'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
    formComponent.formRef.current?.setFieldValue('PostalCountry', '');
  }
}

//Suburb控件 找自动Suburb和Postcode
export function searchSuburbChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&state=' + formComponent.formRef.current.getFieldValue('State'))
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((suburb, j) => {
            options.push({ label: suburb.Name + ' (' + suburb.Postcode + ')', value: suburb.Name + ' (' + suburb.Postcode + ')', data: suburb });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('Suburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
}


//PostalSuburb控件 找自动PostalSuburb和PostalPostcode
export function searchPostalSuburbChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&state=' + formComponent.formRef.current.getFieldValue('PostalState'))
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((suburb, j) => {
            options.push({ label: suburb.Name + ' (' + suburb.Postcode + ')', value: suburb.Name + ' (' + suburb.Postcode + ')', data: suburb });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//PostalSuburb 选择后快速填写数据
export function searchPostalSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.Postcode);
}

